import moment from "moment";
import {
  GET_PROFILE_INIT,
  GET_PROFILE_SUCCESS,
  GET_PROFILE_FAILED,
  GET_ALL_INVESTOR_INIT,
  GET_ALL_INVESTOR_SUCCESS,
  GET_ALL_INVESTOR_FAILED,
  UPDATE_INFO_INIT,
  UPDATE_INFO_SUCCESS,
  UPDATE_INFO_FAILED,
  GET_STRATEGY_INIT,
  GET_STRATEGY_SUCCESS,
  GET_STRATEGY_FAILED,
  UPDATE_COVER_IMAGE_INIT,
  UPDATE_COVER_IMAGE_SUCCESS,
  UPDATE_COVER_IMAGE_FAILED,
  UPDATE_COMPANY_LOGO_INIT,
  UPDATE_COMPANY_LOGO_SUCCESS,
  UPDATE_COMPANY_LOGO_FAILED,
  SEARCH_PMRESULT_INIT,
  SEARCH_PMRESULT_SUCCESS,
  SEARCH_PMRESULT_FAILED,
  SEARCH_REPORTRESULT_INIT,
  SEARCH_REPORTRESULT_SUCCESS,
  SEARCH_REPORTRESULT_FAILED,
  SEARCH_RPRESULT_INIT,
  SEARCH_RPRESULT_SUCCESS,
  SEARCH_RPRESULT_FAILED,
  GET_FUND_DETAIL_INIT,
  GET_FUND_DETAIL_SUCCESS,
  GET_FUND_DETAIL_FAILED,
  UPLOAD_FILE_DECK_INIT,
  UPLOAD_FILE_DECK_SUCCESS,
  UPLOAD_FILE_DECK_FAILED,
  UPLOAD_TEAR_SHEET_INIT,
  UPLOAD_TEAR_SHEET_SUCCESS,
  UPLOAD_TEAR_SHEET_FAILED,
  GET_CLOUD_DECKS_INIT,
  GET_CLOUD_DECKS_SUCCESS,
  GET_CLOUD_DECKS_FAILED,
  GET_MEDIA_INIT,
  GET_MEDIA_SUCCESS,
  GET_MEDIA_FAILED,
  GET_INVESTED_ALLOCATORS_INIT,
  GET_INVESTED_ALLOCATORS_SUCCESS,
  GET_INVESTED_ALLOCATORS_FAILED,
  GET_ALLOCATOR_USERS_INIT,
  GET_ALLOCATOR_USERS_SUCCESS,
  GET_ALLOCATOR_USERS_FAILED
} from "./constants";
const initialState = {
  loading: false,
  myProfileState: [],
  getAllInvestors: [],
  fundDecks: [],
  fundMedia: {},
  reportExtractData: [],
  riskReportMonthList: [],
  fund: {},
  fundId: 0,
  monthlyReturnPerformance: [],
  performanceMetrcisMonth: [],
  fundStats: [],
  profileDetails: {},
  updateTenantDetail: [],
  stratagies: [],
  coverImageUrl: "",
  companyLogoUrl: "",
  pmLoading: false,
  fileDeckLoading: false,
  tearSheetLoading: false,
  deckLoading: false,
  mediaLoading: false,
  fundLoading:false,
  investedAllocator : [],
  allocatorLoading : false,
  allocatorUsers : [],
};

const months = {
  1: "january",
  2: "february",
  3: "march",
  4: "april",
  5: "may",
  6: "june",
  7: "july",
  8: "august",
  9: "september",
  10: "october",
  11: "november",
  12: "december",
};


export default function profile(state = initialState, action) {
  const toObject = (arr) => {
    return arr.reduce(function (acc, cur, i) {
      acc[months[cur.month]] = cur.monthlyReturn?.toFixed(2);
      return acc;
    }, {});
  };
  switch (action.type) {
    case GET_PROFILE_INIT:
      return { ...state, loading: true };
    case GET_PROFILE_SUCCESS:
      const fundData = action.payload.fund;
      let performanceMetrics = [];
      let fundStats = [];
      if (fundData?.id === window._env_.EthosFundId) {
        const publicFund = action.payload.funds[0];
        fundStats = [
          {
            annualVolatility: "",
            annualizedReturn: "",
            followed: true,
            id: 7,
            isPrivate: publicFund?.isPrivate,
            monthlyReturn: publicFund?.monthlyReturn,
            name: publicFund?.name,
            ytd: publicFund?.ytd,
          },
          {
            annualVolatility: publicFund?.annualVolatility,
            annualizedReturn: publicFund?.annualizedReturn,
            id: 0,
            monthlyReturn: "",
            name: window._env_.EthosFundTitle,
            ytd: "",
          }
        ]
      }
      fundData?.monthlyReturnPerformances.map((p) => {
        return performanceMetrics.push({
          year: p.year,
          ytd: p.ytd,
          ...toObject(p.monthsData),
        });
      });

      const publicFunds = fundData?.id === window._env_.EthosFundId ? fundStats : action.payload.funds ;
      return {
        ...state,
        loading: false,
        myProfileState: action.payload,
        monthlyReturnPerformance: performanceMetrics,
        // fundDecks: action?.payload.decks,
        fund: fundData,
        fundId: fundData.id,
        fundStats: publicFunds
      };
    case GET_PROFILE_FAILED:
      return { ...state, loading: false };
    case GET_FUND_DETAIL_INIT:
      return { ...state, fundLoading: true, fund: {}, reportExtractData: {} };
    case GET_FUND_DETAIL_SUCCESS:
      const currentFund = action.payload
      let performance = [];

      currentFund?.monthlyReturnPerformances.map((p) => {
        return performance.push({
          year: p.year,
          ytd: p.ytd,
          ...toObject(p.monthsData),
        });
      });
      return {
        ...state,
        fundLoading: false,
        monthlyReturnPerformance: performance,
        fund: currentFund,
        fundId: currentFund.id
      };
    case GET_FUND_DETAIL_FAILED:
      return { ...state, fundLoading: false };
    case SEARCH_PMRESULT_INIT:
      return { ...state, pmLoading: true };
    case SEARCH_PMRESULT_SUCCESS:
      return { ...state, performanceMetrcisMonth: action.payload, pmLoading: false };
    case SEARCH_PMRESULT_FAILED:
      return { ...state, pmLoading: false };

    case SEARCH_RPRESULT_INIT:
      return { ...state, pmLoading: true };
    case SEARCH_RPRESULT_SUCCESS:
      return { ...state, riskReportMonthList: action.payload, pmLoading: false };
    case SEARCH_RPRESULT_FAILED:
      return { ...state, pmLoading: false };
    case GET_ALL_INVESTOR_INIT:
      return { ...state, loading: true, getAllInvestors: [] };
    case GET_ALL_INVESTOR_SUCCESS:
      return { ...state, loading: false, getAllInvestors: action.payload };
    case GET_ALL_INVESTOR_FAILED:
      return { ...state, loading: false };
    case SEARCH_REPORTRESULT_INIT:
      return { ...state, pmLoading: true };
    case SEARCH_REPORTRESULT_SUCCESS:
      return { ...state, reportExtractData: action.payload, pmLoading: false };
    case SEARCH_REPORTRESULT_FAILED:
      return { ...state, pmLoading: false };
    case UPDATE_INFO_INIT:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_INFO_SUCCESS:
      return {
        ...state,
        loading: false,
        // updateTenantDetail: action.payload,
        myProfileState: action.payload,
      };
    case UPDATE_INFO_FAILED:
      return { ...state, tenantLoading: false };
    case GET_STRATEGY_INIT:
      return {
        ...state,
        stratagies: []
      };
    case GET_STRATEGY_SUCCESS:
      return {
        ...state,
        stratagies: action.payload,
      };
    case GET_STRATEGY_FAILED:
      return { ...state };
    case UPDATE_COVER_IMAGE_INIT:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_COVER_IMAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        coverImageUrl: action.payload,
      };
    case UPDATE_COVER_IMAGE_FAILED:
      return { ...state, loading: false };

    case UPDATE_COMPANY_LOGO_INIT:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_COMPANY_LOGO_SUCCESS:
      return {
        ...state,
        loading: false,
        companyLogoUrl: action.payload,
      };
    case UPDATE_COMPANY_LOGO_FAILED:
      return { ...state, loading: false };

    case UPLOAD_FILE_DECK_INIT:
      return { ...state, fileDeckLoading: true };
    case UPLOAD_FILE_DECK_SUCCESS:
      return {
        ...state,
        fileDeckLoading: false,
        fundDecks: [...state?.fundDecks, action.payload],
      };
    case UPLOAD_FILE_DECK_FAILED:
      return { ...state, fileDeckLoading: false };

    case UPLOAD_TEAR_SHEET_INIT:
      return { ...state, tearSheetLoading: true };
    case UPLOAD_TEAR_SHEET_SUCCESS:
      let monthtear = [...state.monthlyReturnPerformance];
      let yearExists = false;

      let updattedTearSheet = monthtear.reduce((acc, item, i) => {
        let uploadMonth = moment(action.payload.month);
        let monthKey = uploadMonth.format("MMMM").toLowerCase();
        if (item.year === uploadMonth.year()) {
          yearExists = true;
          if (monthKey in item) {
            item[monthKey] = action.payload.monthlyReturn.toString();
          } else {
            item[monthKey] = action.payload.monthlyReturn.toString();
          }
        }
        return [...acc, item];
      }, []);

      if (!yearExists) {
        updattedTearSheet = [
          ...updattedTearSheet,
          {
            year: moment(action.payload.month).year(),
            [moment(action.payload.month).format("MMMM").toLowerCase()]:
              action.payload.monthlyReturn,
          },
        ];
      }

      return {
        ...state,
        tearSheetLoading: false,
        monthlyReturnPerformances: updattedTearSheet,
      };
    case UPLOAD_TEAR_SHEET_FAILED:
      return { ...state, tearSheetLoading: false };
    case GET_CLOUD_DECKS_INIT:
      return {
        ...state,
        deckLoading: true,
      };
    case GET_CLOUD_DECKS_SUCCESS:
      return {
        ...state,
        deckLoading: false,
        fundDecks: action.payload,
      };
    case GET_CLOUD_DECKS_FAILED:
      return { ...state, deckLoading: false };

    case GET_MEDIA_INIT:
      return {
        ...state,
        mediaLoading: true,
      };
    case GET_MEDIA_SUCCESS:
      var media = {
        record: action.payload
      };
      return {
        ...state,
        mediaLoading: false,
        fundMedia: media
      };
    case GET_MEDIA_FAILED:
      return { ...state, mediaLoading: false };

    case GET_INVESTED_ALLOCATORS_INIT:
      return {
        ...state,
        allocatorLoading: true,
      };
    case GET_INVESTED_ALLOCATORS_SUCCESS:
      return {
        ...state,
        allocatorLoading : false,
        investedAllocator: action.payload
      };
    case GET_INVESTED_ALLOCATORS_FAILED:
      return { ...state, allocatorLoading: false };
    case GET_ALLOCATOR_USERS_INIT:
      return {
        ...state,
      };
    case GET_ALLOCATOR_USERS_SUCCESS:
      return {
        ...state,
        allocatorUsers: action.payload
      };
    case GET_ALLOCATOR_USERS_FAILED:
      return { ...state };
    default:
      return state;
  }
}
